import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { computed, type PropType } from 'vue';
import { useI18n } from 'vue-i18n';

import { modalVariant, type ModalVariant } from '@exchange/libs/modals/src';


export default /*#__PURE__*/_defineComponent({
  __name: 'ErrorModal',
  props: {
  /** Title lokalise key */
  titleKey: { type: String, required: false },
  /** Message lokalise key */
  messageKey: { type: String, required: false },
  /** Message to show */
  message: { type: String, required: false },
  /** Can close modal */
  canClose: { type: Boolean, default: true },
  /** Close button lokalise key */
  closeButtonKey: { type: String, required: false },
  variant: { type: String as PropType<ModalVariant>, default: modalVariant.dark },
},
  emits: ["x-error-close"],
  setup(__props, { emit: __emit }) {

const props = __props;

const emit = __emit;

const { t } = useI18n({ useScope: 'global' });

const getText = (defaultKey: string, key?: string) => {
  if (key) {
    return t(key);
  }

  return t(defaultKey);
};

const errorMessage = computed(() => props.message || getText('modules.errors.errorModal.defaultMessage', props.messageKey));

const title = computed(() => getText('modules.errors.errorModal.title', props.titleKey));

const closeButtonText = computed(() => getText('modules.errors.errorModal.button', props.closeButtonKey));

return (_ctx: any,_cache: any) => {
  const _component_x_button = _resolveComponent("x-button")!
  const _component_x_modal = _resolveComponent("x-modal")!

  return (_openBlock(), _createBlock(_component_x_modal, {
    "can-close": __props.canClose,
    title: title.value,
    variant: __props.variant,
    class: "error-modal",
    type: "base"
  }, {
    content: _withCtx(() => [
      _createElementVNode("p", null, _toDisplayString(errorMessage.value), 1)
    ]),
    buttons: _withCtx(() => [
      _createVNode(_component_x_button, {
        ref: "ok",
        variant: "primary",
        text: closeButtonText.value,
        onClick: _cache[0] || (_cache[0] = ($event: any) => (emit('x-error-close')))
      }, null, 8, ["text"])
    ]),
    _: 1
  }, 8, ["can-close", "title", "variant"]))
}
}

})